import apiService from "../../../service/Api";
import { MemoryBookEntry } from "../components/MemoryBookCard";

export type MemoryBookWidgetStatus = "overdue" | "in_danger" | "safe";

export interface MemoryBookWidgetEntryApi {
  id: number;
  stream_id: number;
  deceased_name: string;
  deceased_avatar_url: string | null;
  due_date: string | null;
  status: MemoryBookWidgetStatus;
  comment_count: number;
  progress_percent: number;
  assignees: {
    id: number;
    assignment_id: number;
    name: string;
    avatar_url: string | null;
    role: "scanner" | "uploader" | "both" | "other" | null;
  }[];
}

export interface MemoryBookWidgetStaffApi {
  id: number;
  name: string;
  avatar_url: string | null;
  assigned_count: number;
}

export interface MemoryBookWidgetResponse {
  counts: {
    entries: {
      overdue: number;
      in_danger: number;
      safe: number;
    };
    assignments: {
      overdue: number;
      in_danger: number;
    };
  };
  entries: MemoryBookWidgetEntryApi[];
  staff: MemoryBookWidgetStaffApi[];
}

const formatTimeInfo = (dueDate?: string | null): string => {
  if (!dueDate) return "";
  const due = new Date(dueDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  due.setHours(0, 0, 0, 0);
  const days = Math.ceil(
    (due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24),
  );
  if (days < 0) {
    return `${Math.abs(days)} day${Math.abs(days) !== 1 ? "s" : ""} ago`;
  }
  if (days === 0) return "Due today";
  if (days === 1) return "Due tomorrow";
  return due.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
};

export const mapWidgetEntryToMemoryBookEntry = (
  entry: MemoryBookWidgetEntryApi,
): MemoryBookEntry => ({
  id: entry.id,
  streamId: entry.stream_id,
  deceasedName: entry.deceased_name,
  deceasedAvatarUrl: entry.deceased_avatar_url ?? undefined,
  assignees: entry.assignees.map((a) => ({
    id: a.id,
    assignmentId: a.assignment_id,
    name: a.name,
    avatarUrl: a.avatar_url ?? undefined,
    role: a.role,
  })),
  timeInfo: formatTimeInfo(entry.due_date),
  commentCount: entry.comment_count,
  progressPercent: entry.progress_percent,
  status: entry.status,
});

export const fetchMemoryBookWidget = () => {
  return apiService.get<MemoryBookWidgetResponse>(
    "/api/streams/memory-book-widget/",
  );
};
